import { AttachMoney, CalendarToday, Description } from '@mui/icons-material';
import { Box, Grid, Typography } from '@mui/material';
import { Surplus } from 'lib/api/reports/types';
import { formatDate, formatMoney } from 'lib/functions/utils';
import React from 'react';

import InfoRow from './InfoRow';

interface DocumentSectionProps {
  surplus: Surplus;
}

const DocumentSection: React.FC<DocumentSectionProps> = ({ surplus }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box
        sx={{
          backgroundColor: 'rgba(25, 118, 210, 0.08)',
          borderRadius: '8px',
          px: 1.5,
          py: 0.8,
          border: '1px solid rgba(25, 118, 210, 0.15)',
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 600,
            color: 'primary.main',
            fontSize: '0.75rem',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            textAlign: 'center',
          }}
        >
          Documento
        </Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <InfoRow
            label="Rut Cliente"
            value={surplus.businessIdentifier}
            maxLength={40}
            icon={
              <Description sx={{ fontSize: '0.8rem', color: 'primary.main' }} />
            }
          />
          <InfoRow
            label="Nombre Cliente"
            value={surplus.businessName}
            maxLength={40}
            icon={
              <Description sx={{ fontSize: '0.8rem', color: 'primary.main' }} />
            }
          />
          <InfoRow
            label="Folio"
            value={surplus.documentFolio}
            maxLength={40}
            icon={
              <Description sx={{ fontSize: '0.8rem', color: 'primary.main' }} />
            }
          />
          <InfoRow
            label="ID Solicitud"
            value={String(surplus.factoringRequestId)}
            maxLength={40}
            icon={
              <Description sx={{ fontSize: '0.8rem', color: 'primary.main' }} />
            }
          />
          <InfoRow
            label="Estado Solicitud"
            value={surplus.factoringRequestStatus}
            maxLength={40}
            icon={
              <Description sx={{ fontSize: '0.8rem', color: 'primary.main' }} />
            }
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <InfoRow
            label="Monto"
            value={formatMoney(surplus.documentAmount)}
            maxLength={40}
            icon={
              <AttachMoney sx={{ fontSize: '0.8rem', color: 'primary.main' }} />
            }
          />
          <InfoRow
            label="Monto Anticipado"
            value={formatMoney(surplus.documentAdvanced)}
            maxLength={40}
            icon={
              <AttachMoney sx={{ fontSize: '0.8rem', color: 'primary.main' }} />
            }
          />
          <InfoRow
            label="Monto Conciliado Documento"
            value={formatMoney(surplus.documentConciliationAmount)}
            maxLength={40}
            icon={
              <AttachMoney sx={{ fontSize: '0.8rem', color: 'primary.main' }} />
            }
          />
          <InfoRow
            label="Monto Conciliado Mora"
            value={formatMoney(surplus.arrearConciliationAmount)}
            maxLength={40}
            icon={
              <AttachMoney sx={{ fontSize: '0.8rem', color: 'primary.main' }} />
            }
          />
          <InfoRow
            label="Monto Conciliado Total"
            value={formatMoney(surplus.totalConciliationAmount)}
            maxLength={40}
            icon={
              <AttachMoney sx={{ fontSize: '0.8rem', color: 'primary.main' }} />
            }
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <InfoRow
            label="Fecha Operación"
            value={formatDate(new Date(surplus.factoringRequestOperationDate))}
            maxLength={40}
            icon={
              <CalendarToday
                sx={{ fontSize: '0.8rem', color: 'primary.main' }}
              />
            }
          />
          <InfoRow
            label="Fecha Vencimineto"
            value={formatDate(new Date(surplus.documentPaymentDate))}
            maxLength={40}
            icon={
              <CalendarToday
                sx={{ fontSize: '0.8rem', color: 'primary.main' }}
              />
            }
          />
          <InfoRow
            label="Fecha Pago"
            value={
              surplus.documentPaidAt
                ? formatDate(new Date(surplus.documentPaidAt))
                : null
            }
            maxLength={40}
            icon={
              <CalendarToday
                sx={{ fontSize: '0.8rem', color: 'primary.main' }}
              />
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default DocumentSection;
